import { getIntl } from "../../localization/intl";

/**
 * @deprecated moved to errorUtils.ts
 */
export function getErrorMessage(code: string) {
	const codeMessages = {
		// Added this one to handle 401 Unauthorized status as it does not allow to have body. Find a good way to handle this situation
		"Please re-authenticate.": getIntl().formatMessage({ id: "AUTH.error.invalid-credentials" }), //"Invalid username or password",
		"validation-error.": getIntl().formatMessage({ id: "AUTH.error.invalid-credentials" }), //"Invalid username or password",
		"auth/email-already-exists": getIntl().formatMessage({ id: "AUTH.error.email-already-exists" }), //"User already exists",
		"auth/invalid-credentials": getIntl().formatMessage({ id: "AUTH.error.invalid-credentials" }), //"Invalid username or password",
		"auth/room-not-available": getIntl().formatMessage({ id: "AUTH.error.room-not-available" }), //"Room is not available",
		"auth/room-inaccessible": getIntl().formatMessage({ id: "AUTH.error.room-inaccessible" }), //"You're not allowed to enter the room",
		"auth/room-not-exist": getIntl().formatMessage({ id: "AUTH.error.room-not-exist" }), //"Room does not exist",
		"auth/passwordless-registration-not-allowed": getIntl().formatMessage({
			id: "AUTH.error.passwordless-registration-not-allowed",
		}), // "Passwordless not allowed"
		"auth/email-not-part-of-organization": getIntl().formatMessage({
			id: "AUTH.error.email-not-part-of-organization",
		}),
	};

	return codeMessages[code] || getIntl().formatMessage({ id: "AUTH.error.internal-server-error" });
}
